import React from 'react'
import { pick } from 'lodash-es'
import { useTbViewStore } from '@vt/hooks'
import { Button } from '@ow/comps'

const Recycle = function ({ children }) {
  const { showRecycle, setShowRecycle } = useTbViewStore((state) =>
    pick(state, ['showRecycle', 'setShowRecycle'])
  )

  return (
    <div className="flex items-center gap-2">
      {showRecycle && (
        <Button
          type="primary"
          onClick={() => {
            setShowRecycle(false)
          }}
        >
          返回
        </Button>
      )}
      {!showRecycle && (
        <div
          onClick={() => {
            setShowRecycle(true)
          }}
        >
          {children}
        </div>
      )}
    </div>
  )
}

export default Recycle
